import React, { PropsWithChildren } from 'react';
import { StoreProvider as EasyPeasyProvider } from 'easy-peasy';
import store from '../store';

const StoreProvider: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <EasyPeasyProvider store={store}>{children}</EasyPeasyProvider>;
};

export default StoreProvider;
